module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/ogimage-238b5e4f4e007b639727accb837e7f8d.jpg";